export default __webpack_public_path__ + "static/media/ExploreTheDeep_09.ddac7ee9.png";